import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsExtended() {
  const testimonials = [{
    initials: 'MP',
    name: 'Marcela P.',
    loc: 'Buenos Aires 🇦🇷',
    text: 'Compré un sábado. El domingo a la noche tenía el mes de clases listo. Nunca más improviso el lunes a la mañana.'
  }, {
    initials: 'LG',
    name: 'Laura G.',
    loc: 'Córdoba 🇦🇷',
    text: 'Tres nenas de jardín que no podían hacer el rol adelante limpio lo lograron en el primer mes con el Tomo 1.'
  }, {
    initials: 'SR',
    name: 'Sebastián R.',
    loc: 'Rosario 🇦🇷',
    text: 'Antes tardaba 2 horas armando la clase. Ahora abro el tomo, veo la semana y en 10 minutos tengo todo.'
  }, {
    initials: 'VF',
    name: 'Valeria F.',
    loc: 'Mendoza 🇦🇷',
    text: 'El Cazador de Décimas cambió cómo trabajo la ejecución. Mis alumnas subieron el puntaje en el primer torneo sin cambiar ningún elemento.'
  }, {
    initials: 'PA',
    name: 'Pablo A.',
    loc: 'Santa Fe 🇦🇷',
    text: 'El Código de las Dificultades me salvó con una alumna que tenía el flic-flac bloqueado hace 4 meses. En 3 semanas lo estaba haciendo sola.'
  }, {
    initials: 'CR',
    name: 'Carolina R.',
    loc: 'Tucumán 🇦🇷',
    text: 'El Nivelómetro 360 cambió cómo evalúo a mis grupos. Ahora los padres entienden exactamente en qué nivel está su hija y por qué.'
  }];
  return <section className="py-20 bg-slate-50" data-id="element-259">
      <div className="max-w-6xl mx-auto px-4" data-id="element-260">
        <div className="text-center mb-12" data-id="element-261">
          <h2 className="text-3xl font-extrabold text-gray-900 mb-2" data-id="element-262">
            Lo que dicen los profesores
          </h2>
          <div className="flex items-center justify-center gap-2 text-yellow-400 font-bold text-xl" data-id="element-263">
            4.9/5 <Star className="w-6 h-6 fill-yellow-400" data-id="element-264" />
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-265">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-266">
              <div className="flex items-center gap-4 mb-4" data-id="element-267">
                <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center font-bold text-slate-600" data-id="element-268">
                  {t.initials}
                </div>
                <div data-id="element-269">
                  <p className="font-bold text-gray-900" data-id="element-270">{t.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-271">{t.loc}</p>
                </div>
              </div>
              <div className="flex gap-1 mb-3" data-id="element-272">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-273" />)}
              </div>
              <p className="text-gray-700 text-sm leading-relaxed italic" data-id="element-274">
                "{t.text}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}